
import { getMessengerLink, externalProfileLink } from "~/common/helpers";
import CShowPhone from "~/components/v2/ui/c-show-phone.vue";
import CContactLink from "~/components/v2/ui/c-contact-link.vue";

export default {
  name: "ProfileContactInfo",

  components: {
    CShowPhone,
    CContactLink,
  },

  props: {
    phone: {
      type: String,
      default: "",
    },
    profileId: {
      type: [String, Number],
      required: true,
    },
    messengers: {
      type: [Object, Array],
      default: () => {},
    },
    links: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    normalizedMessengers() {
      if (!this.messengers) return [];

      if (Array.isArray(this.messengers)) {
        if (
          this.messengers.length > 0 &&
          typeof this.messengers[0] === "object" &&
          this.messengers[0] !== null &&
          "title" in this.messengers[0]
        ) {
          return this.messengers.map((item) => item.title || "Unknown");
        }
        return this.messengers.map((item) => {
          if (!item) return "Unknown";
          return typeof item === "object"
            ? item.title || item.name || "Unknown"
            : String(item);
        });
      } else if (
        typeof this.messengers === "object" &&
        this.messengers !== null
      ) {
        return Object.values(this.messengers).map((value) => {
          if (!value) return "Unknown";
          return typeof value === "object"
            ? value.title || value.name || "Unknown"
            : String(value);
        });
      }

      return [];
    },

    filteredLinks() {
      return this.links.filter((item) => {
        if (item.type && item.type.title) {
          return item.type.title !== "Other" || item?.link?.startsWith("http");
        }
        return item.title !== "Other" || item?.link?.startsWith("http");
      });
    },
  },

  methods: {
    getMessengerLink,

    externalProfileLink,

    getExternalProfileLink(item) {
      if (!item) return "";

      if (item.type && item.type.title) {
        return externalProfileLink({
          title: item.type.title,
          link: item.link,
        });
      }

      return externalProfileLink(item);
    },

    getLocalMessengerLink(item, phone) {
      if (!item) return "";

      const messengerName =
        typeof item === "object" && item !== null
          ? item.title || item.name || item.type || "Unknown"
          : String(item);

      return getMessengerLink(messengerName, phone);
    },

    getLinkTitle(item) {
      if (!item) return "Link";

      if (item.type && item.type.title) {
        if (item.type.title === "Other") {
          const link = item.link || "";
          if (link.startsWith("http")) {
            try {
              return new URL(link).hostname.replace("www.", "");
            } catch (e) {
              return "Link";
            }
          } else if (!link.startsWith("@")) {
            return "@" + link;
          } else {
            return link;
          }
        }
        return item.type.title;
      }

      if (item.title) {
        if (item.title === "Other") {
          const link = item.link || "";
          if (link.startsWith("http")) {
            try {
              return new URL(link).hostname.replace("www.", "");
            } catch (e) {
              return "Link";
            }
          } else if (!link.startsWith("@")) {
            return "@" + link;
          } else {
            return link;
          }
        }
        return item.title;
      }

      return "Link";
    },

    getSocialIconName(item) {
      if (item.type && item.type.title) {
        return item.type.title;
      }

      if (item.title) {
        return item.title;
      }

      return "Link";
    },

    copyNumber(e, item) {
      if (!item) return;

      const messengerName =
        typeof item === "object" && item !== null
          ? item.title || item.name || item.type || "Unknown"
          : String(item);

      if (["Signal", "WeChat"].includes(messengerName)) {
        e.preventDefault();
        this.$copyText(
          this.phone,
          this.$refs.phoneComponent.getContainer()
        ).then(() => {
          this.$notify({
            type: "success",
            message: this.$t("phone-copied"),
          });
        });
      }
    },
  },
};
